import React from 'react';

type PageSectionTitleProps = {
  mode?: 'parallax';
  text: string;
};
const PageSectionTitle: React.FC<PageSectionTitleProps> = (props) => {
  const { text, mode } = props;
  if (mode === 'parallax') {
    return <h1 className="max-w-4xl leading-none mt-[20px] md:mt-[100px] mb-[40px] md:mb-[200px]">{text}</h1>;
  }
  return (
    <div className="flex justify-center md:text-center">
      <h1 className="max-w-4xl leading-none mb-[40px] md:mb-[100px]">{text}</h1>
    </div>
  );
};
PageSectionTitle.displayName = 'PageSectionTitle';
export default PageSectionTitle;
